module.exports = __webpack_public_path__ + "static/analytics-sku-level@3x-d847c3c2389000b54efc4cf548710ce3.png";